<mdb-card-body>
    <mdb-card-text>               
        <div class="form-check">
            <input type="radio" class="form-check-input" id="materialChecked" name="materialExampleRadios"
                   [(ngModel)]="template" [value]="templateChecked">
            <label class="form-check-label" style="font-size: 14px;" for="materialChecked">Pago con tarjeta</label>
        </div>
        <br>
    </mdb-card-text>
</mdb-card-body>
<div class="row">
    <div class="col-md-12" style="text-align: right;">
        <button class="btn btn-flat btn-outline-indigo" (click)="onBack()">Regresar<i class="fas fa-arrow-left pl-1"></i></button>
    </div>
</div>
<div class="row">
    <div class="col-md-12" style="text-align: right;">
        <!-- Skeleton loader mientras carga el botón de pago -->
        <div *ngIf="isLoadingPaymentButton" class="payment-skeleton-container">
            <div class="payment-skeleton-message">
                <i class="fas fa-lock"></i>
                <span>Cargando pasarela de pago seguro...</span>
            </div>
            <div class="payment-skeleton-button">
                <div class="skeleton-shimmer"></div>
            </div>
        </div>

        <!-- Botón de pago (se carga dinámicamente) -->
        <div id="btn_pago" [style.display]="isLoadingPaymentButton ? 'none' : 'block'">

        </div>
    </div>
</div>

